import React from 'react';
import Helmet from 'react-helmet';
import { GatsbyImageProps, FixedObject } from 'gatsby-image';

const MOBILE_MAX_WIDTH = 767;

interface Props {
  image?: GatsbyImageProps;
  imageMobile?: GatsbyImageProps;
  noImageOnMobile?: boolean;
}

const getFixed = (image?: GatsbyImageProps): FixedObject | undefined => {
  if (!image || !image.fixed) {
    return undefined;
  }
  return Array.isArray(image.fixed) ? image.fixed[0] : image.fixed;
};

const preloadLink = (fixed: FixedObject, media: string) =>
  ({
    rel: 'preload',
    as: 'image',
    href: fixed.src,
    imagesrcset: fixed.srcSet,
    media,
    fetchpriority: 'high',
  } as any);

const HeroImagePreload = ({ image, imageMobile, noImageOnMobile }: Props) => {
  const desktop = getFixed(image);
  const mobile = noImageOnMobile ? undefined : getFixed(imageMobile);

  if (!desktop && !mobile) {
    return null;
  }

  return (
    <Helmet defer={false}>
      {mobile && <link {...preloadLink(mobile, `(max-width: ${MOBILE_MAX_WIDTH}px)`)} />}
      {desktop && <link {...preloadLink(desktop, `(min-width: ${MOBILE_MAX_WIDTH + 1}px)`)} />}
    </Helmet>
  );
};

export default HeroImagePreload;
